import Vue from 'vue';

export default {
  addCcbInAcc (params) {
    return Vue.axios.post('/api/v1.0/chanquan/acc/addCcbInAcc', params);
  },
  selectListByPage (params) {
    return Vue.axios.post('/api/v1.0/chanquan/userCom/selectListByPage', params);
  },
  // 详情
  selectListById (params) {
    return Vue.axios.post('/api/v1.0/chanquan/userCom/selectListById', params);
  }
};
